import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  IsLoadingReports,
  load,
  SelectOrderedBy,
  setIsLoading,
  SpotlightStatuses as SpotlightStatusesReport,
  loadStatuses,
  SelectSpotlightStatusesLoaded,
} from "../redux/reducers/spotlightReport.reducer";
import { SpotlightService } from "../services/spotlight";
import { getAmountByStatus } from "../utils/overviewTableUtils";
import { SpotlightStatuses } from "../redux/reducers/spotlight.reducer";

export const useSpotlightReports = () => {
  const dispatch = useDispatch();

  const isLoadingReports = useSelector(IsLoadingReports);
  const spotlightStatusesLoaded = useSelector(SelectSpotlightStatusesLoaded);

  const { list: spotlightReports } = useSelector(SelectOrderedBy);

  const spotlightStatusesToFilter = useSelector(SpotlightStatusesReport);
  const spotlightStatuses = useSelector(SpotlightStatuses);

  const loadReports = useCallback(async () => {
    dispatch(setIsLoading(true));

    const spotlightReports = await SpotlightService.getSpotlightSummary();
    dispatch(
      load(
        spotlightReports.sort(
          (a: any, b: any) => a.status.sortOrder - b.status.sortOrder
        )
      )
    );

    if (!spotlightStatusesLoaded) {
      const spotlightStatusesToFilter: Array<any> =
        spotlightStatuses.length === 0
          ? await SpotlightService.getSpotlightStatuses()
          : spotlightStatuses;

      spotlightStatusesToFilter.forEach((status: any) => {
        status.amount = getAmountByStatus(spotlightReports, status.id);
      });

      // SET FILTERS TAB ORDER MANUALLY FOR SPOTLIGHT SUMMARY REPORT
      spotlightStatusesToFilter.forEach((elem) => {
        switch (elem.name) {
          case "No Major Issues":
            elem.tabOrder = 5;
            break;
          case "Cautionary":
            elem.tabOrder = 4;
            break;
          case "Critical":
            elem.tabOrder = 2;
            break;
          case "On Hold":
            elem.tabOrder = 6;
            break;
          case "Internal Critical":
            elem.tabOrder = 3;
            break;
        }
      });
      spotlightStatusesToFilter.push({
        amount: spotlightReports.length,
        id: 0,
        name: "All",
        sortOrder: -1,
        tabOrder: 1,
      });
      spotlightStatusesToFilter.sort(
        (a: any, b: any) => a.tabOrder - b.tabOrder
      );

      dispatch(loadStatuses(spotlightStatusesToFilter));
    }
  }, [dispatch]);

  useEffect(() => {
    loadReports();
  }, [loadReports]);

  return {
    spotlightReports,
    loadReports,
    isLoadingReports,
    spotlightStatusesToFilter,
  };
};
